import { CircleExclamation } from '@styled-icons/fa-solid';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { colors } from '~/utils/css-mixins';

const StyledExclamationCircle = styled(CircleExclamation)`
  color: ${colors.change};
`;

const Exclamation = ({ size = '1em' }) => (
  <StyledExclamationCircle size={size} />
);

Exclamation.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Exclamation;
